module.exports = __webpack_public_path__ + "static/img/wechat.455ee314.jpg";